import { toast } from "sonner";

const TECHNICAL_PATTERNS: [RegExp, string][] = [
  [/non-2xx/i, "Something went wrong. Please try again."],
  [/Failed to fetch|NetworkError|ERR_NETWORK|ECONNREFUSED/i, "Unable to connect. Please check your internet connection."],
  [/JWT expired|invalid claim|token.*expired|401/i, "Your session has expired. Please sign in again."],
  [/TypeError|Cannot read propert|undefined is not|null is not/i, "Something went wrong. Please try again."],
  [/ReferenceError|SyntaxError/i, "Something went wrong. Please try again."],
  [/CORS|blocked by|Access-Control/i, "Unable to connect. Please try again later."],
  [/timeout|timed out|ETIMEDOUT/i, "Request timed out. Please try again."],
  [/rate limit|too many requests|429/i, "Too many requests. Please wait a moment and try again."],
  [/500 Internal Server|internal server error/i, "Something went wrong on our end. Please try again later."],
  [/503 Service Unavailable/i, "Service temporarily unavailable. Please try again later."],
  [/Edge Function returned/i, "Something went wrong. Please try again."],
];

/**
 * Sanitise an error message for end-user display.
 * Returns the original string if it already looks user-friendly.
 */
export function friendlyError(
  errOrMsg: unknown,
  fallback = "Something went wrong. Please try again.",
): string {
  let msg = fallback;

  if (typeof errOrMsg === "string") {
    msg = errOrMsg;
  } else if (errOrMsg instanceof Error) {
    msg = errOrMsg.message || fallback;
  } else if (errOrMsg && typeof (errOrMsg as any).message === "string") {
    msg = (errOrMsg as any).message;
  }

  if (!msg || msg.trim() === "") return fallback;

  // Check against known technical patterns
  for (const [pattern, friendly] of TECHNICAL_PATTERNS) {
    if (pattern.test(msg)) return friendly;
  }

  // Strip stack traces (lines starting with "at ")
  if (msg.includes("\n")) {
    msg = msg.split("\n")[0].trim();
  }

  return msg || fallback;
}

/**
 * Drop-in replacement for `toast.error(err.message)`.
 */
export const friendlyToast = {
  error(errOrMsg: unknown, fallback?: string) {
    toast.error(friendlyError(errOrMsg, fallback));
  },
  success(msg: string) {
    toast.success(msg);
  },
};
